'use client';

import { IntakeFormShell } from './_sections/IntakeFormShell';
import { useIntakeFormState } from './useIntakeFormState';
import { useGetConfig } from '../ChatBot';

type Props = {
  engageId: string;
  sessionId: string;
  threadId: string;
  onCompleted: () => void;
};

export function IntakeFormCard(props: Props) {
  const config = useGetConfig();
  const form = useIntakeFormState({
    ...props,
    captureMclidCookie: config.captureMclidCookie === true,
    viewerCountry: config.viewerCountry,
  });
  const agentName = config.agentName || 'Assistant';
  const institutionName = config.institutionName || agentName;

  return (
    <IntakeFormShell
      agentName={agentName}
      institutionName={institutionName}
      values={form.values}
      detectedIso={form.values.prefillIso}
      errors={form.errors}
      emailSuggestion={form.emailSuggestion}
      submitError={form.submitError}
      submitting={form.submitting}
      formRef={form.formRef}
      bannerRef={form.bannerRef}
      onChange={form.onChange}
      onBlurField={form.onBlurField}
      onApplyEmailSuggestion={form.applyEmailSuggestion}
      onClearSubmitError={form.clearSubmitError}
      onSubmit={form.onSubmit}
    />
  );
}
